import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface HierarchyBreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function HierarchyBreadcrumb({ items }: HierarchyBreadcrumbProps) {
  const { t } = useTranslation();
  return (
    <nav className="flex items-center gap-1 text-sm text-surface-500 flex-wrap" dir="rtl" aria-label={t('aria.breadcrumb')}>
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-1">
          {idx > 0 && <ChevronLeft size={14} className="text-surface-300" />}
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-600 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-surface-800 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
